let scroll = window.requestAnimationFrame

const elementsToShow = document.querySelectorAll( '.animate' )
const animationActionClass = 'animated'


const init = function() {
    if ( window.requestAnimationFrame ) {
        loop()
    } else {
        showAllAnimationElements()
    }
}


const loop = function() {
    watchForAnimationElements()
    updateTimelineSectionClasses()
    scroll( loop )
}


const updateTimelineSectionClasses = function() {

    const timelineSection = document.querySelector( '.timeline-section' )

    if ( !timelineSection ) return

    const windowHeight = window.innerHeight
    const timeLineRect = timelineSection.getBoundingClientRect()

    // Only run this if the timeline section is within the viewport
    if ( timeLineRect.top <= ( windowHeight / 2 ) && timeLineRect.bottom >= windowHeight ) {

        const progress = ( timeLineRect.top * -1 ) / timeLineRect.height * 100

        if ( progress <= 20 ) {
            timelineSection.classList.add('is-light')
            timelineSection.classList.remove('is-dark')
        } else if ( progress > 20 && progress <= 60  ) {
            timelineSection.classList.add('is-dark')
            timelineSection.classList.remove('is-light')
        } else if ( progress > 60 ) {
            timelineSection.classList.add('is-light')
            timelineSection.classList.remove('is-dark')
        }

    }

}


const watchForAnimationElements = function() {
    elementsToShow.forEach( ( element ) => {
        if ( isElementInViewport( element ) ) {
            if ( element.classList.contains( animationActionClass ) ) return
            element.classList.add( animationActionClass )
        }
    } )
}


const isElementInViewport = function( element ) {

    const rect = element.getBoundingClientRect()

    return (
        ( rect.top <= 0 && rect.bottom >= 0 )
        ||
        ( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
        ||
        ( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
    )

}


const showAllAnimationElements = function() {

    elementsToShow.forEach( element => { element.classList.add( animationActionClass ) } )

}


const api = {
    init: init
}

export default api;
